import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "../../../components/modal";

const View = (props, ref) => {
    const [show, setShow] = useState(false);
    const [data, setData] = useState({});

    useImperativeHandle(ref, () => ({
        open(data) {
            setShow(true);
            setData(data);
        },
    }));

    return (
        <Modal size={"lg"} show={show} setShow={setShow}>
            <div className="flex justify-start flex-col items-start gap-y-2" style={{wordBreak: 'break-word'}}>
                <p className="text-lg font-semibold">
                    General Info:
                </p>

                <p className="md:text-lg text-sm font-light">
                    Name: {data?.fullname}
                </p>
                <p className="md:text-lg text-sm font-light">
                    Email: {data?.email}
                </p>
                <p className="md:text-lg text-sm font-light">
                    Company: {data?.company_name}
                </p>
                <p className="md:text-lg text-sm font-semibold">Query:</p>
                <div className="md:text-lg text-sm font-light">
                    {data?.query || "No info provided!"}
                </div>
            </div>
        </Modal>
    );
};

export default forwardRef(View);
